/**
 * @Author: DJ
 * @Date:   2021-07-08 16:21:56
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-07-08 16:28:43
 */
/**
 *  参数设置
 * */
import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./index.module.scss";
import {
  message,
  InputNumber,
  Spin,
  Empty,
  Switch,
  Checkbox,
  Input,
} from "antd";
import { XOKButton } from "@/components/xqxc_ui";
import http from "@/assets/api/http";
import PropTypes from "prop-types";
import model from "@/reducers/system/parameter/model";
import { regYuanToFen, regFenToYuan } from "@/util/money";
import { FloatConversion } from "@/util/conversion";

class RiskParams extends Component {
  state = {
    loading: false,
    floatConversion: new FloatConversion(),
    riskList: [], //渲染的数据
    spinLoading: true,
    itemLoading: {},
  };

  componentDidMount() {
    this.props.getlistCompanyParamByParamType({});
  }

  componentDidUpdate(prevProps) {
    console.log("prevProps ----- ", prevProps);
    if (
      this.props.listCompanyParamByParamType !==
      prevProps.listCompanyParamByParamType
    ) {
      this.renderRisk(this.props.listCompanyParamByParamType);
    }
  }

  //保存
  _savehandle = (item) => {
    const { floatConversion } = this.state;
    let submit;
    let value = item.paramValue;
    const ratio = Number(item.aratio) || 0;
    if (ratio > 0) {
      const vNum = Number(value);
      value = isNaN(vNum) ? value : vNum * ratio;
    }
    submit = { paramCode: item.paramCode, paramValue: value };

    // if (
    //   item.paramCode === "ALI_PHONE_WARINING_SMS_TEL" &&
    //   item.paramValue &&
    //   item.paramValue !== ""
    // ) {
    //   let regList = item.paramValue.split(",");
    //   if (regList && regList.length > 0) {
    //     const reg = new RegExp(/^1[3|4|5|6|7|8|9][0-9]{9}$/);
    //     for (let it of regList) {
    //       if (!reg.test(it)) {
    //         message.warning("请检查报警短信名单手机号格式是否错误");
    //         return false;
    //       }
    //     }
    //   }
    // }

    this.setState(
      (prev) => ({
        itemLoading: { ...prev.itemLoading, [item.paramCode]: true },
      }),
      () => {
        console.log("--------- riskparams 提交数据 ---------", submit);
        http(
          "/?cmd=com.xqxc.api.pig.mis.biz.platform.CompanyParamMisService.updateCompanyParamValue&group=mis",
          submit,
          "POST"
        )
          .then((response) => {
            message.success("保存成功");
            this.props.getlistCompanyParamByParamType({});
            this.setState((prev) => ({
              itemLoading: { ...prev.itemLoading, [item.paramCode]: false },
            }));
          })
          .catch((e = {}) => {
            message.error(e.message);
            this.setState((prev) => ({
              itemLoading: { ...prev.itemLoading, [item.paramCode]: false },
            }));
          });
      }
    );
  };

  renderRisk = (obj) => {
    const { floatConversion } = this.state;
    let risk = [];
    if (Object.keys(obj).length > 0) {
      let arr = [];
      for (let key in obj) {
        arr.push(obj[key]);
      }
      risk = arr.map((v) => {
        let data;
        try {
          data = JSON.parse(v.formatJson || "{}");
        } catch (e) {
          data = {};
        }
        const inputType = (data && data.inputType) || "text";
        if (inputType === "text") {
          v.atype = "InputNumber";
        } else if (inputType === "textarea") {
          v.atype = "TextArea";
        } else if (inputType === "switch") {
          v.atype = "Switch";
        } else {
          v.atype = "InputNumber";
        }
        v.attr = v.paramAttr;
        v.aprecision = Number(data.scale);
        v.aratio = Number(data.ratio);
        if (v.aratio > 0) {
          const pv = Number(v.paramValue);
          v.paramValue = isNaN(pv) ? v.paramValue : pv / v.aratio;
        }
        v.amin = data && data.min != null ? Number(data.min) : 0;
        v.amax = data && data.max != null ? Number(data.max) : 999999;
        v.aremark = v.remark;
        return v;
      });
    }
    this.setState({ riskList: risk, spinLoading: false });
  };

  render() {
    const { loading, riskList, spinLoading } = this.state;

    return (
      <div className={styles.flexBoxContainer}>
        <div
          className={styles.tableContainer}
          style={{ overflow: "hidden auto" }}
        >
          <div className={styles.spin}>
            <Spin spinning={spinLoading} size="large" />
          </div>
          {!spinLoading && riskList.length > 0
            ? riskList.map((v, index) => {
                return (
                  <div className={styles.riskcontent} key={index}>
                    <div className={styles.item}>
                      <div className={styles.title}>
                        <h4>{v.attr}</h4>
                        <h5>{v.paramCode}</h5>
                      </div>
                      <p>{v.aremark}</p>
                      {v.atype == "InputNumber" && (
                        <div>
                          <InputNumber
                            inputStyle={{ width: "100px" }}
                            placeholder="请输入"
                            // defaultValue={v.paramValue}
                            value={v.paramValue}
                            precision={v.aprecision}
                            min={v.amin}
                            max={v.amax}
                            onChange={(value) => {
                              let arrt = this.state.riskList.map((item) => {
                                if (item.paramCode == v.paramCode) {
                                  item.paramValue = value ? value : v.amin;
                                  return item;
                                }
                                return item;
                              });
                              this.setState({ riskList: arrt });
                            }}
                          />
                        </div>
                      )}
                      {v.atype == "Switch" && (
                        <div
                          style={{
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                          }}
                        >
                          <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={v.paramValue == 1 ? true : false}
                            onChange={(value) => {
                              let arrt = this.state.riskList.map((item) => {
                                if (item.paramCode == v.paramCode) {
                                  item.paramValue = value ? 1 : 0;
                                  return item;
                                }
                                return item;
                              });
                              this.setState({ riskList: arrt });
                            }}
                          />
                        </div>
                      )}
                      {v.atype == "CheckboxGroup" && (
                        <div>
                          <Checkbox.Group
                            value={[
                              v.paramValue.split(";")[0] == 0
                                ? undefined
                                : "first",
                              v.paramValue.split(";")[1] == 0
                                ? undefined
                                : "last",
                            ]}
                            options={v.list}
                            onChange={(values) => {
                              let arrt = this.state.riskList.map((item) => {
                                if (item.paramCode == v.paramCode) {
                                  let paramValue = "0;0";
                                  if (
                                    values[0] == "first" &&
                                    values[1] == "last"
                                  ) {
                                    paramValue = "1;1";
                                  } else if (values[0] == "first") {
                                    paramValue = "1;0";
                                  } else if (values[0] == "last") {
                                    paramValue = "0;1";
                                  } else {
                                    paramValue = "0;0";
                                  }
                                  item.paramValue = paramValue;
                                  return item;
                                }
                                return item;
                              });
                              this.setState({ riskList: arrt });
                            }}
                          />
                        </div>
                      )}
                      {v.atype === "TextArea" && (
                        <div>
                          <Input.TextArea
                            rows={2}
                            value={v.paramValue}
                            onChange={(e) => {
                              let arrt = this.state.riskList.map((item) => {
                                if (item.paramCode == v.paramCode) {
                                  item.paramValue = e.target.value.replace(
                                    "，",
                                    ","
                                  );
                                  return item;
                                }
                                return item;
                              });
                              this.setState({ riskList: arrt });
                            }}
                          ></Input.TextArea>
                        </div>
                      )}
                      <div className={styles.layout}>
                        <XOKButton
                          loading={
                            this.state.itemLoading &&
                            this.state.itemLoading[v.paramCode]
                          }
                          onClick={() => this._savehandle(v)}
                          label="保存"
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
          {!spinLoading && riskList.length === 0 ? <Empty /> : null}
          <div className={styles.info}>
            <span>!</span>
            点击保存之前，以上参数默认均取自平台设定，保存之后则取本地设置
          </div>
        </div>
      </div>
    );
  }
}

RiskParams.propTypes = {
  listCompanyParamByParamType: PropTypes.array,
  getlistCompanyParamByParamType: PropTypes.func, //参数数据(action)
};

const mapStateToProps = (state) => ({
  listCompanyParamByParamType: state.parameter.listCompanyParamByParamType,
});

export default connect(mapStateToProps, { ...model.actions })(RiskParams);
